import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, Tooltip } from '@mui/material';
import { useColorMode } from '@/theme/colorMode';

export function ThemeToggle() {
  const { mode, toggleMode } = useColorMode();
  const nextMode = mode === 'light' ? 'dark' : 'light';

  return (
    <Tooltip title={`Switch to ${nextMode} mode`}>
      <IconButton color="inherit" onClick={toggleMode} aria-label={`Switch to ${nextMode} mode`}>
        {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
